import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Button, Alert, Row, Col, NavLink } from 'reactstrap';
import { AvForm, AvGroup, AvField } from 'availity-reactstrap-validation';
import i18n from '../i18next';

import MenuuLogoSVG from '../images/MenuuLogoSVG';
import { MESSAGE_LEVEL_ERROR, MESSAGE_LEVEL_SUCCESS } from "../utils/Constants";
import { changeLoginEmail, changeLoginPassword, clearMessage, login } from '../actions';
import { Link } from "react-router-dom";
import LoginScreenLeftSide from './LoginScreenLeftSide';

class LoginScreen extends Component {

	componentDidMount() {
		setTimeout(() => {
			if (document.getElementById('logo')) {
				document.getElementById('logo').classList.add('showLogInLogo');
			}
		}, 1);
	}

	componentWillMount() {
		// If user is already logged in from previous usage
		// then open directly the home screen, i.e. restaurants
		if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
			this.props.history.push('/restaurants');
		}
	}

	changeEmail(event) {
		const email = event.target.value;
		this.props.changeLoginEmail(email);
	}

	changePassword(event) {
		const password = event.target.value;
		this.props.changeLoginPassword(password);
	}

	login() {
		const { email, password } = this.props;
		this.props.login(email, password)
	}

	renderMessage() {
		const { alertStyle } = styles;

		if (this.props.message.text !== undefined && this.props.message.text !== null && this.props.message.text !== '') {
			// Dismiss the message after 3 seconds because if you don't close it,  it appear again after you logged in.
			const errorMessage = (this.props.message.level === MESSAGE_LEVEL_ERROR);

			if (errorMessage) {
				setTimeout(() => {
					this.props.clearMessage();
				}, 3000);
			}
			const successMessage = (this.props.message.level === MESSAGE_LEVEL_SUCCESS);
			const color = successMessage ? 'success' : 'danger';

			const dismiss = this.props.clearMessage.bind(this);

			return (
				<div style={alertStyle}>
					<Alert color={color} toggle={dismiss}>
						{this.props.message.text}
					</Alert>
				</div>
			);
		} else {
			return (
				<div/>
			);
		}
	}

	render() {
		const { loginScreenContainer, formContainer, loginButton, forgotPasswordText, column } = styles;
		const isLeftSideHidden = window.innerWidth <= 768;
		let additionalFormContainer = {}, additionalHeadingStyles = {};

		if (window.outerWidth <= 414) {
			additionalFormContainer.width = '90%';
			additionalFormContainer.padding = '0px 12px';
			additionalHeadingStyles.fontSize = 35;
		} else if (window.innerWidth <= 768) {
			additionalFormContainer.width = 410;
		}

		return (
			<Container fluid style={loginScreenContainer}>
				<Row style={{ height: '100%' }}>
					{
						isLeftSideHidden ?
							<a href='https://menuu.com' id='logo' className='logInLogo'>
								<MenuuLogoSVG
									width={150} height={150} fill={'#373737'}
								/>
							</a>
							: <LoginScreenLeftSide />
					}

					<Col md={isLeftSideHidden ? 12 : 7} style={column}>
						<div style={Object.assign({}, formContainer, additionalFormContainer)}>
							<h2 style={Object.assign({}, { fontWeight: 600, fontSize: 45, marginTop: 0, marginBottom: 14 }, additionalHeadingStyles)}>Log In to Menuu.</h2>
							<AvForm onValidSubmit={this.login.bind(this)}>
								<AvGroup>
									<AvField
										style={{ paddingLeft: 0, paddingBottom: 0, color: '#363636', fontSize: 18, border: 'none', borderBottomWidth: 1, borderBottomStyle: 'solid', borderBottomColor: '#b7b7b7' }}
										placeholder={i18n.t('common:form.email')}
										type="email" name="email" className='loginFields'
										value={this.props.email}
										onChange={this.changeEmail.bind(this)}
										required
										errorMessage={i18n.t('common:validations.errorMsg')}
										// validate={{
										// 	pattern: {
										// 		value: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$',
										// 		errorMessage: i18n.t('common:validations.errorMsgEmail')
										// 	}
										// }}
									/>
								</AvGroup>
								<AvGroup>
									<AvField
										style={{ paddingLeft: 0, paddingBottom: 0, color: '#363636', fontSize: 18, border: 'none', borderBottomWidth: 1, borderBottomStyle: 'solid', borderBottomColor: '#b7b7b7' }}
										placeholder={i18n.t('common:form.password')}
										type="password" name="password" id="password" className='loginFields'
										value={this.props.password}
										onChange={this.changePassword.bind(this)}
										required
										errorMessage={i18n.t('common:validations.errorMsg')}
									/>
								</AvGroup>
								<NavLink tag={Link} to="/forgotten-password" style={{ paddingLeft: 10 }}>
									<p style={forgotPasswordText}>{i18n.t('screens:loginScreen.forgottenPass')}</p>
								</NavLink>
								<br />
								<Button className='loginBtn' style={loginButton} >{i18n.t('screens:loginScreen.login')}</Button>
							</AvForm>
							<p style={{ paddingTop: 30, fontSize: 18, color: '#363636' }}>{i18n.t('screens:loginScreen.noAcc')} <a style={{ color: '#2F2F2F', textDecoration: 'underline', fontSize: 17, fontWeight: 700 }} href="https://menuu.com/get-started">
								<strong>{i18n.t('screens:loginScreen.signup')}</strong>
							</a>
							</p>
						</div>
					</Col>
				</Row>
				{this.renderMessage()}
			</Container>
		);
	}
}

const mapStateToProps = state => {
	return {
		email: state.user.email,
		password: state.user.password,
		message: state.message
	};
};

export default connect(mapStateToProps, { changeLoginEmail, changeLoginPassword, login, clearMessage })(LoginScreen);

let styles = {
	formContainer: {
		width: 420,
		margin: 'auto'
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		padding: 0
	},
	loginButton: {
		height: 'auto',
		backgroundColor: '#363636',
		border: 'none',
		boxShadow: '0px 8px 20px 0px rgba(35, 31, 32, 0.27)',
		color: '#ffffff',
		fontFamily: 'neue-haas-grotesk-display, sans-serif',
		fontWeight: 600,
		fontSize: 22,
		padding: 20
	},
	forgotPasswordText: {
		fontSize: 14,
		marginLeft: -12,
		color: '#2f2f2f',
		marginBottom: 0,
		textDecoration: 'underline'
	},
	alertStyle: {
		position: 'fixed',
		top: '70px',
		left: '0',
		right: '0',
		width: '400px',
		height: '50px',
		marginLeft: 'auto',
		marginRight: 'auto'
	},
	loginScreenContainer: {
		height: '100%',
		fontFamily: 'neue-haas-grotesk-display, sans-serif',
		fontStyle: 'normal',
		fontWeight: 100
	}
}


// WEBPACK FOOTER //
// ./src/components/LoginScreen.js